// extracted by mini-css-extract-plugin
module.exports = {"slottedDropdown":"NsProductQuantitySelector_slottedDropdown_2yL-d","customInput":"NsProductQuantitySelector_customInput_1Ocpk","small":"NsProductQuantitySelector_small_2hskM"};